import { ActionTree, GetterTree, MutationTree } from 'vuex'
import { IViolenceCardState } from './model'
import { IRootState } from '@/store/model'

const states: IViolenceCardState = {
  filters: []
}

const mutations: MutationTree<IViolenceCardState> = {
  SET_EMPLOYEE_FILTER: (state, data: any) => {
    state.filters = data
  },
  FLUSH_EMPLOYEE_FILTER: (state) => {
    state.filters = []
  }
}

const actions: ActionTree<IViolenceCardState, IRootState> = {
  setViolenceCardFilter: async ({ commit }, data) => {
    commit('SET_EMPLOYEE_FILTER', data)
  },
  flushViolenceCardFilter: async ({ commit }) => {
    commit('FLUSH_EMPLOYEE_FILTER')
  }
}

const getters: GetterTree<IViolenceCardState, IRootState> = {
  getViolenceCardFilter(state) {
    return state.filters
  }
}

export default {
  namespaced: true,
  state: states,
  mutations,
  actions,
  getters
}